import React, { useEffect, useState } from "react";
import {
  getRequest,
  postRequest,
} from "../../../../../../services/api/apiService";
import { toast } from "react-toastify";

const ConnectedPlatformAccountLinkedInConfigurationModal = ({
  platformName,
  headers,
  onClose,
  handleFetchConnectedPlatforms,
}) => {
  const [linkedInAdsAccountId, setLinkedInAdsAccountId] = useState("");
  const [availableLinkedInAdsAccountIds, setAvailableLinkedInAdsAccountIds] =
    useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAvailableAccounts = async () => {
      try {
        const response = await getRequest("/api/ads/linkedin/ad-accounts", { ...headers });
        const accounts = response?.data?.accounts || [];
        setAvailableLinkedInAdsAccountIds(accounts);
        // Pre-select the account that is already saved
        const savedId = response?.data?.selectedLinkedInAdvertiserId;
        if (savedId) setLinkedInAdsAccountId(String(savedId));
      } catch (err) {
        setError("Failed to fetch LinkedIn ad accounts.");
      }
    };

    fetchAvailableAccounts();
  }, []);

  const saveLinkedInAccessToken = async () => {
    if (!linkedInAdsAccountId) {
      setError("Please select a LinkedIn Ads Account ID.");
      return;
    }

    try {
      setLoading(true);
      setError(null);

      await postRequest(
        "/api/ads/linkedin/save-linkedin-ads-account",
        { linkedinAdvertiserId: linkedInAdsAccountId },
        { ...headers }
      );

      toast.success("LinkedIn Ads Account updated successfully!");
      onClose();
      handleFetchConnectedPlatforms();
    } catch (err) {
      setError("An error occurred while saving the LinkedIn Ads account.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            LinkedIn Ads Account ID
          </label>
          <select
            value={linkedInAdsAccountId}
            onChange={(e) => setLinkedInAdsAccountId(e.target.value)}
            className="mt-1 p-2 w-full border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none z-10"
          >
            <option value="" disabled>
              Select LinkedIn Account ID
            </option>
            {availableLinkedInAdsAccountIds.map((option) => (
              <option key={option?.id} value={option?.id}>
                {`${option?.id} (${option?.name})`}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="text-xs text-gray-500 italic mb-6">
        The ID of your LinkedIn Ads account
      </div>

      {error && <div className="text-red-500 text-sm mb-4">{error}</div>}

      <div className="flex justify-end gap-4">
        <button
          onClick={onClose}
          className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300"
        >
          Cancel
        </button>
        <button
          onClick={saveLinkedInAccessToken}
          disabled={loading}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400"
        >
          {loading ? "Saving..." : "Save"}
        </button>
      </div>
    </div>
  );
};

export default ConnectedPlatformAccountLinkedInConfigurationModal;
